module.exports = __webpack_public_path__ + "static/img/changjing2.4be7ea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/changjing2.jpg
// module id = R1Q7
// module chunks = 73